module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.data,
      "cell-class-name": _vm.cellClass,
      "header-cell-class-name": _vm.cellClass
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shortName",
      "label": "Name",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RTA",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rta",
      "label": "Active",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtaRejected",
      "label": "Rejected",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtaClosed",
      "label": "Closed",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RTS",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rts",
      "label": "Active",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtsRejected",
      "label": "Rejected",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtsClosed",
      "label": "Closed",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RTU",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rtu",
      "label": "Active",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtuRejected",
      "label": "Rejected",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtuClosed",
      "label": "Closed",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RTB",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rtb",
      "label": "Active",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtbRejected",
      "label": "Rejected",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtbClosed",
      "label": "Closed",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RTD",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rtd",
      "label": "Active",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtdRejected",
      "label": "Rejected",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rtdClosed",
      "label": "Closed",
      "align": "center"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" Requests by Sharers")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a0a362"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/requests/SummaryRequests.vue
// module id = 1304
// module chunks = 0